import LayoutBasic from "@/views/layouts/LayoutBasic";
import CustomersOrderRequests from "@/views/customersRequests/Orders";
import customersRequestsCallbacks from "@/views/customersRequests/Callbacks";
import customersRequestsAvailables from "@/views/customersRequests/Availables";
import BotChats from "@/views/customersRequests/BotChats.vue";

const routes = {
  path: '/customersRequests',
  component: LayoutBasic, // Change the desired Layout here,
  meta: {requiresAuth: true},
  children: [
    {
      path: 'chats',
      component: BotChats,
      name: 'ClientsChats',
      meta: {
        // allowedTo: [ROLES.ID.SuperAdmin],
        permission: 'clientsChats'
      }
    },
    {
      path: 'orders',
      component: CustomersOrderRequests,
      name: 'CustomersOrderRequests',
      meta: {
        // allowedTo: [ROLES.ID.SuperAdmin],
        permission: 'customersRequests'
      }
    },
    {
      path: 'callbacks',
      component: customersRequestsCallbacks,
      name: 'customersRequestsCallbacks',
      meta: {
        // allowedTo: [ROLES.ID.SuperAdmin],
        permission: 'customersRequests'
      }
    },
    {
      path: 'presence',
      component: customersRequestsAvailables,
      name: 'customersRequestsAvailables',
      meta: {
        // allowedTo: [ROLES.ID.SuperAdmin],
        permission: 'customersRequests'
      }
    },
  ]
}

export default routes;
